// extracted by mini-css-extract-plugin
export default {"container":"FeaturedTable_container__xet0u","tableWrapper":"FeaturedTable_tableWrapper__kOTUG","table":"FeaturedTable_table__b5XQB"};